export function downloadCsv(filename: string, rows: Record<string, unknown>[]) {
  const safeRows = rows || [];
  const headers = Array.from(
    safeRows.reduce<Set<string>>((acc, row) => {
      Object.keys(row || {}).forEach((k) => acc.add(k));
      return acc;
    }, new Set<string>()),
  );

  const escape = (value: unknown) => {
    if (value === null || value === undefined) return '';
    const str = String(value);
    if (/[",\n]/.test(str)) return `"${str.replace(/"/g, '""')}"`;
    return str;
  };

  const lines = [headers.join(',')].concat(
    safeRows.map((row) => headers.map((h) => escape(row[h])).join(',')),
  );

  // Leading BOM — without it Excel reads the file as ANSI and mojibakes
  // Traditional Chinese names.
  const blob = new Blob(['﻿' + lines.join('\n')], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

